<template>
  <div class="chart-data-panel">
    <chart-data-tile
      v-for="(dataObj, key, index) in data"
      :key="index"
      :value="dataObj.value"
      :isLeadingTile="key === 'all'"
      :themeColor="themeColor"
      :label="dataObj.label" />
  </div>
</template>

<script>
import ChartDataTile from './ChartDataTile'
import appConfig from '../app-config.json'

export default {
  name: 'chart-data-panel',
  components: { ChartDataTile },
  props: {
    data: {
      type: Object
    },
    themeColor: {
      type: String,
      validator: value => {
        return appConfig.themeColors.hasOwnProperty(value)
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../assets/variables';

  .chart-data-panel {
    border: 1px solid rgba($brand-white, .25);
    border-radius: 2px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    overflow: hidden;
    margin-bottom: 15px;

    div {
      &:not(:first-of-type) {
        width: 48%;
        flex: 1;
      }

      &:first-of-type {
        width: 100%;
        display: flex;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ChartDataPanel.vue